import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  constructor(private readonly http: HttpService) {}

  downloadFile(url: string, filename: string): void {
    // this.http.downloadFile(url).subscribe((response: Blob) => {
    //   this.saveFile(response, filename);
    // });

    this.http.downloadFile(url).subscribe((res) => {
      if(res){
       const blob = new Blob([res.body], { type: res.type });
       const url = window.URL.createObjectURL(blob);
       var a = document.createElement('a');
       a.href = url;
       a.download = filename ;
       document.body.appendChild(a);
       a.click();
       setTimeout(() => {
         a.remove();
       }, 100);
      }
    });
  }

  // private saveFile(data: Blob, filename: string) {
  //   // const blob = new Blob([data], { type: data.type });
  //   // const url = window.URL.createObjectURL(blob);
    
  //   // const a = document.createElement('a');
  //   // a.href = url;
  //   // a.download = filename;
  //   // a.click();

  //   // setTimeout(() => {
  //   //   a.remove();
  //   //   window.URL.revokeObjectURL(url);
  //   // }, 100);
  //  }
}
